import _classCallCheck from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * Implementation of the {@link module:core/editor/utils/dataapimixin~DataApi}.
 */
export default function DataApiMixin(base) {
  var Mixin = /*#__PURE__*/function (_base) {
    _inherits(Mixin, _base);
    var _super = _createSuper(Mixin);
    function Mixin() {
      _classCallCheck(this, Mixin);
      return _super.apply(this, arguments);
    }
    _createClass(Mixin, [{
      key: "setData",
      value: function setData(data) {
        this.data.set(data);
      }
    }, {
      key: "getData",
      value: function getData(options) {
        return this.data.get(options);
      }
    }]);
    return Mixin;
  }(base);
  return Mixin;
}
// Backward compatibility with `mix`.
{
  var mixin = DataApiMixin(Object);
  DataApiMixin.setData = mixin.prototype.setData;
  DataApiMixin.getData = mixin.prototype.getData;
}